import { render, staticRenderFns } from "./Prolong.vue?vue&type=template&id=f4703902&scoped=true&"
import script from "./Prolong.vue?vue&type=script&lang=js&"
export * from "./Prolong.vue?vue&type=script&lang=js&"
import style0 from "./Prolong.vue?vue&type=style&index=0&id=f4703902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4703902",
  null
  
)

export default component.exports